import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
import { ReactNode } from 'react';
import { AnimatedCollapse } from 'components/AnimatedCollapse';
import { Icon } from 'components/Icon';
import { Button } from 'components/Button';

export type Props = {
  summary: ReactNode;
  className?: string;
  headingClassName?: string;
  id?: string;
  defaultOpen?: boolean;
};

export const AccordionListItem: React.FC<Props> = ({
  summary,
  children,
  className,
  headingClassName,
  defaultOpen,
  id,
}): JSX.Element => {
  return (
    <section id={id} className={cx('group', className)}>
      <AnimatedCollapse defaultOpen={defaultOpen}>
        {({ isOpen }) => (
          <>
            <AnimatedCollapse.Trigger
              className={twMerge(
                cx(
                  'w-full flex items-center justify-between gap-24 md:gap-40',
                  'font-semibold',
                  `py-24 px-40 sm-d:px-32`,
                  'text-left',
                  headingClassName,
                ),
              )}
            >
              {summary}

              <Button
                iconOnly
                className={cx('h-40 w-40 md-d:h-48 md-d:w-48 group-hover:bg-purple-300 shrink-0', {
                  'border-black-100% border-2': isOpen,
                })}
                as="div"
              >
                <Icon
                  name="AngleDown"
                  className={cx('flex-shrink-0 w-24 transition-transform text-black-100%', {
                    'rotate-180': isOpen,
                  })}
                />
              </Button>
            </AnimatedCollapse.Trigger>

            <AnimatedCollapse.Contents className="px-40 sm-d:px-32 pb-24">{children}</AnimatedCollapse.Contents>
          </>
        )}
      </AnimatedCollapse>
    </section>
  );
};
